export const removeUrlQueryParams = ({ history, params }) => {
  const searchParams = new URLSearchParams(history.location.search)
  params.forEach((paramName) => searchParams.delete(paramName))
  return { pathname: history.location.pathname, search: `?${searchParams.toString()}` }
}
